module.exports = __webpack_public_path__ + "img/section5_img1_1.9ea06a6a.svg";